// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  --btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  --btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
  --dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;
}

.project_table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
  background-color: #ffffff;
}
.project_table.autoLayout {
  table-layout: auto;
}
.project_table.fixedLayout {
  table-layout: fixed;
}
.project_table th {
  overflow: hidden;
  white-space: nowrap; /* Запрет переноса текста в ячейках */
  overflow: hidden; /* Скрываем излишки текста */
  text-overflow: ellipsis;
}
.project_table td {
  font-style: italic;
  font-weight: 400;
  overflow: hidden;
  text-align: right;
  align-items: left;
  padding: 3px 5px;
  border-right: 0.02px solid rgba(88, 89, 93, 0.2941176471);
}
.project_table td:last-child {
  border-right: 0;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.project_table.lastChildCentered td:last-child {
  text-align: center;
  justify-content: center;
  align-items: center;
}

@media screen and (min-width: 1024px) and (max-width: 1439px) {
  .kpf_table_overflow {
    width: 100em;
  }
}

.block_table {
  display: inline-block;
  border-spacing: 0;
}
.block_table .dnd_theader {
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 2;
}
.block_table .dnd_theader .th {
  background: #dae1ec;
}
.block_table .tr :last-child .td {
  border-bottom: 0;
}
.block_table .th,
.block_table .td {
  text-align: right;
  margin: 0;
  padding: 0.5rem;
  border-bottom: 1px solid rgba(88, 89, 93, 0.2078431373);
  border-right: 1px solid rgba(88, 89, 93, 0.2078431373);
  position: relative;
}
.block_table .th .disable,
.block_table .td .disable {
  color: rgba(79, 81, 82, 0.3490196078);
  background-color: rgba(82, 82, 82, 0.0509803922);
}
.block_table .th :last-child,
.block_table .td :last-child {
  border-right: 0;
}
.block_table .th.th_res,
.block_table .td.th_res {
  width: 1.7em;
}
.block_table .th .resizer,
.block_table .td .resizer {
  background: #f9f9f9;
  width: 0.4em;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(50%);
  z-index: 1;
  touch-action: none;
}
.block_table .th .resizer.isResizing,
.block_table .td .resizer.isResizing {
  background: rgb(88, 168, 218);
}
.block_table .item_selected {
  font-weight: 550;
  background-color: rgba(66, 108, 166, 0.0470588235);
}
.block_table .th {
  text-align: center;
}
.block_table .td {
  font-style: italic;
  font-weight: 400;
}

.project_list {
  max-width: 100%;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  background: #ffffff;
  background: #ffffff;
  border-bottom: 0;
  position: relative;
  overflow-x: auto;
  box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;
}
.project_list.scrollX {
  overflow-x: auto;
}
.project_list tr:nth-child(even) {
  background-color: rgba(233, 241, 251, 0.4);
}
.project_list tr:nth-child(odd) {
  background-color: white;
}
.project_list tbody tr[data-readonly=false]:hover {
  background-color: rgba(66, 108, 166, 0.1843137255);
}
.project_list:focus {
  outline: none;
}
.project_list td .expand_cell_text {
  display: none;
}
.project_list td .expand_sign {
  text-align: center;
  width: 100%;
}
.project_list td.expanded {
  background-color: powderblue;
  white-space: normal;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
}
.project_list td.expanded .expand_cell_text {
  display: block;
}

.project_list_kp {
  max-width: 100%;
  height: 100%;
  overflow-x: hidden;
  background: #ffffff;
  margin-bottom: 5px;
  background: #ffffff;
  border: 1px solid rgba(88, 89, 93, 0.2078431373);
  border-bottom: 0;
  position: relative;
}
.project_list_kp.scrollX {
  overflow-x: scroll;
}
.project_list_kp .kpf_table_tr:hover {
  background-color: rgba(66, 108, 166, 0.1843137255);
}

.row-even {
  background-color: rgba(233, 241, 251, 0.4);
}

.row-odd {
  background-color: white;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.566);
}

::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.486);
}

.radio_container {
  display: flex;
  justify-content: center;
}

.circules_box {
  width: 14px;
  height: 14px;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
}
.circules_box .circule1 {
  position: absolute;
  top: 0;
  left: 0;
  height: 14px;
  width: 14px;
  background-color: #eee;
  border-radius: 50%;
}
.circules_box .circule2 {
  position: absolute;
  top: 3.3px;
  left: 3.3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.availability_circule_box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0 5px;
}
.availability_circule_box .outer_circle {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: content-box;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: white;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
}
.availability_circule_box .outer_circle .inner_circle {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.item_selected td {
  text-decoration: underline;
  font-weight: 550;
  background-color: rgba(191, 205, 226, 0.6666666667);
}

td {
  white-space: nowrap; /* Запрет переноса текста на новую строку */
  overflow: hidden; /* Скрытие текста, выходящего за пределы ячейки */
  text-overflow: ellipsis;
}

.table {
  max-width: 48vw;
  display: inline-block;
  border-spacing: 0;
}
.table .tr :last-child .td {
  border-bottom: 0;
}
.table .th,
.table .td {
  margin: 0;
  padding: 0.5rem;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  position: relative;
}
.table .th :last-child,
.table .td :last-child {
  border-right: 0;
}
.table .th .resizer,
.table .td .resizer {
  display: inline-block;
  background: blue;
  width: 5px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(50%);
  z-index: 1;
  touch-action: none;
}
.table .th .resizer.isResizing,
.table .td .resizer.isResizing {
  background: red;
}

.table_container {
  max-width: 50vw;
}

thead {
  width: 100%;
  position: sticky;
  height: auto;
  top: 0;
  background: white;
  z-index: 50;
  overflow: auto;
  border-bottom: 0.01px solid rgba(88, 89, 93, 0.2941176471);
  border-collapse: separate;
}
thead th {
  border-collapse: separate;
  font-style: normal;
  font-weight: 500;
  color: #426ba6;
  align-items: center;
  text-align: center;
  border-right: 0.01px solid rgba(88, 89, 93, 0.2941176471);
  border-bottom: 0.01px solid rgba(88, 89, 93, 0.2941176471);
}
thead th:last-child {
  border-right: 0;
}

table thead {
  border-collapse: separate;
}
table tbody {
  border-collapse: collapse;
}

.table_with_bb {
  max-width: 100%;
  overflow-x: scroll;
  background: #ffffff;
  margin-bottom: 5px;
  background: #ffffff;
  border: 1px solid rgba(88, 89, 93, 0.2078431373);
  border-bottom: 0;
  position: relative;
}
.table_with_bb thead {
  height: 1.5em;
}
.table_with_bb thead tr {
  background-color: rgba(66, 108, 166, 0.1843137255);
}
.table_with_bb table tr {
  border-bottom: 1px solid rgba(66, 108, 166, 0.231372549);
}
.table_with_bb table tr:hover {
  background-color: rgba(66, 108, 166, 0.1843137255);
}
.table_with_bb table tr:last-child {
  border-bottom: 0;
}

.table_dnd_container {
  overflow-x: scroll;
}
.table_dnd_container .project_list {
  overflow-x: scroll;
}

.table_xscroll__container .project_list {
  overflow-x: auto;
}

.reactTableRow {
  cursor: pointer;
}
.reactTableRow:hover, .reactTableRow:active {
  background-color: rgba(191, 205, 226, 0.2941176471);
}

.longColumnWrap {
  height: auto;
  vertical-align: top;
  white-space: pre;
  word-wrap: break-word;
}

.tar {
  text-align: right;
}

.m0 {
  margin: 0;
}

.sortableHeader {
  position: relative;
  cursor: pointer;
}
.sortableHeader::after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 6px;
  height: 6px;
  background-image: linear-gradient(to bottom right, transparent 50%, #426ba6 0);
}

.oneRow_table {
  height: 4em;
}

.strikethroughRow {
  position: relative;
  text-decoration: line-through;
  color: #a3b9d9;
}

.accentRow {
  color: #b72025;
}

.resizer {
  position: absolute;
  top: 0;
  height: 100%;
  right: 0;
  width: 5px;
  background: rgba(0, 0, 0, 0.5);
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
}

.resizer.isResizing {
  background: blue;
  opacity: 1;
}

@media (hover: hover) {
  .resizer {
    opacity: 0;
  }
  *:hover > .resizer {
    opacity: 1;
  }
}
.react-table-disabled-td {
  background-color: rgba(128, 128, 128, 0.1803921569) !important;
  color: gray;
}

.react-table-disabled-td-todo {
  color: #a3b9d9;
}

tr.reactTableRow.react-table-linethrough {
  color: #a3b9d9;
  text-decoration: line-through;
}`, "",{"version":3,"sources":["webpack://./src/Styles/List.scss","webpack://./src/Components/App/vars.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC8ChB;EACE,sDAAA;EACA,0DAAA;EACA,2GAAA;EACA,kDAAA;AD5CF;;AAAA;EAGE,WAAA;EACA,yBAAA;EAEA,mBAAA;EACA,yBAAA;AAAF;AAME;EACE,kBAAA;AAJJ;AAOE;EACE,mBAAA;AALJ;AAQE;EACE,gBAAA;EACA,mBAAA,EAAA,qCAAA;EACA,gBAAA,EAAA,4BAAA;EACA,uBAAA;AANJ;AASE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yDAAA;AAPJ;AAQI;EACE,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AANN;AAYM;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AAVR;;AAwCE;EADF;IAEI,YAAA;EApCF;AACF;;AAuCA;EACE,qBAAA;EACA,iBAAA;AApCF;AAyCE;EACE,gBAAA;EACA,MAAA;EAGA,yBAAA;EACA,UAAA;AAzCJ;AA0CI;EACE,mBAAA;AAxCN;AAiDM;EACE,gBAAA;AA/CR;AAoDE;;EAEE,iBAAA;EACA,SAAA;EACA,eAAA;EACA,uDAAA;EACA,sDAAA;EAEA,kBAAA;AAnDJ;AAoDI;;EACE,qCAAA;EACA,gDAAA;AAjDN;AAmDI;;EACE,eAAA;AAhDN;AAkDI;;EACE,YAAA;AA/CN;AAkDI;;EAEE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,0BAAA;EACA,UAAA;EAEA,kBAAA;AAjDN;AAmDM;;EACE,6BAAA;AAhDR;AAoDE;EAGE,gBAAA;EACA,kDAAA;AApDJ;AAuDE;EACE,kBAAA;AArDJ;AAwDE;EACE,kBAAA;EACA,gBAAA;AAtDJ;;AA0DA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0FCxJiB;AD+FnB;AA2DE;EACE,gBAAA;AAzDJ;AA2DE;EAEE,0CAAA;AA1DJ;AA6DE;EACE,uBAAA;AA3DJ;AAgEM;EACE,kDAAA;AA9DR;AAkEE;EACE,aAAA;AAhEJ;AAoEI;EACE,aAAA;AAlEN;AAoEI;EAEE,kBAAA;EACA,WAAA;AAnEN;AAsEE;EACE,4BAAA;EACA,mBAAA;EACA,+EAAA;AApEJ;AAyEI;EACE,cAAA;AAvEN;;AA4EA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;EACA,kBAAA;AAzEF;AA0EE;EACE,kBAAA;AAxEJ;AA2EE;EACE,kDAAA;AAzEJ;;AA4EA;EACE,0CAAA;AAzEF;;AA4EA;EACE,uBAAA;AAzEF;;AA4EA;EACE,UAAA;AAzEF;;AA2EA;EACE,qDAAA;AAxEF;;AA0EA;EACE,qDAAA;AAvEF;;AAyEA;EACE,aAAA;EACA,uBAAA;AAtEF;;AAwEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EAGA,iBAAA;AArEF;AAuEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AArEJ;AAuEE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AArEJ;;AAyEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;AAtEF;AAwEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,uBAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,uBAAA;EACA,iDAAA;AAxEJ;AA0EI;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAxEN;;AA8EE;EACE,0BAAA;EACA,gBAAA;EACA,mDAAA;AA3EJ;;AA+EA;EACE,mBAAA,EAAA,2CAAA;EACA,gBAAA,EAAA,iDAAA;EACA,uBAAA;AA5EF;;AA+EA;EACE,eAAA;EACA,qBAAA;EACA,iBAAA;AA5EF;AAiFM;EACE,gBAAA;AA/ER;AAoFE;;EAEE,SAAA;EACA,eAAA;EACA,8BAAA;EACA,6BAAA;EACA,kBAAA;AAlFJ;AAoFI;;EACE,eAAA;AAjFN;AAoFI;;EACE,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,0BAAA;EACA,UAAA;EAEA,kBAAA;AAlFN;AAoFM;;EACE,eAAA;AAjFR;;AAuFA;EACE,eAAA;AApFF;;AAuFA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,MAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,0DAAA;EACA,yBAAA;AApFF;AAqFE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EAEA,yDAAA;EACA,0DAAA;AApFJ;AAqFI;EACE,eAAA;AAnFN;;AAwFE;EACE,yBAAA;AArFJ;AAuFE;EACE,yBAAA;AArFJ;;AAyFA;EACE,eAAA;EAEA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;EACA,kBAAA;AAvFF;AAyFE;EACE,aAAA;AAvFJ;AAwFI;EACE,kDAAA;AAtFN;AA0FI;EACE,wDAAA;AAxFN;AAyFM;EACE,kDAAA;AAvFR;AAyFM;EACE,gBAAA;AAvFR;;AA6FA;EAGE,kBAAA;AA5FF;AAyGE;EACE,kBAAA;AAvGJ;;AA2GE;EACE,gBAAA;AAxGJ;;AAoHA;EACE,eAAA;AAjHF;AAmHE;EAGE,mDAAA;AAnHJ;;AAuHA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AApHF;;AAuHA;EACE,iBAAA;AApHF;;AAuHA;EACE,SAAA;AApHF;;AAuHA;EACE,kBAAA;EACA,eAAA;AApHF;AAsHE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,8EAAA;AApHJ;;AAwHA;EACE,WAAA;AArHF;;AAwHA;EACE,kBAAA;EACA,6BAAA;EACA,cC3hBiB;ADsanB;;AAwHA;EACE,cC3hBY;ADsad;;AAkIA;EACE,kBAAA;EACA,MAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AA/HF;;AAkIA;EACE,gBAAA;EACA,UAAA;AA/HF;;AAkIA;EACE;IACE,UAAA;EA/HF;EAkIA;IACE,UAAA;EAhIF;AACF;AAmIA;EACE,8DAAA;EACA,WAAA;AAjIF;;AAmIA;EACE,cC5kBiB;AD4cnB;;AAkIA;EACE,cC/kBiB;EDglBjB,6BAAA;AA/HF","sourcesContent":["// @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');\n// @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;1,500&display=swap');\n\n@import \"../Components/App/vars.scss\";\n//@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;1,400;1,500&display=swap\");\n\n.project_table {\n  // overflow-y: auto;\n\n  width: 100%;\n  border-collapse: collapse;\n  // table-layout: fixed;\n  white-space: nowrap;\n  background-color: #ffffff;\n\n  table {\n    // table-layout: fixed;\n  }\n\n  &.autoLayout {\n    table-layout: auto;\n  }\n\n  &.fixedLayout {\n    table-layout: fixed;\n  }\n\n  th {\n    overflow: hidden;\n    white-space: nowrap; /* Запрет переноса текста в ячейках */\n    overflow: hidden; /* Скрываем излишки текста */\n    text-overflow: ellipsis;\n  }\n\n  td {\n    font-style: italic;\n    font-weight: 400;\n    overflow: hidden;\n    text-align: right;\n    align-items: left;\n    padding: 3px 5px;\n    border-right: 0.02px solid #58595d4b;\n    &:last-child {\n      border-right: 0;\n      text-align: center;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  &.lastChildCentered {\n    td {\n      &:last-child {\n        text-align: center;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n  }\n\n  // tr {\n  //   height: 10px;\n  // }\n}\n\n// .kpf_table_overflow {\n//   @media screen and (min-width: 1024px) and (max-width: 1439px) {\n//     overflow-x: scroll;\n//   }\n// }\n// .kpf_table_table_width {\n//   width: 120em;\n//   @media screen and (min-width: 1024px) {\n//     height: 10em;\n//   }\n//   @media screen and (min-width: 1440px) {\n//     height: 15em;\n//     width: 100%;\n//   }\n//   @media screen and (min-width: 1805px) {\n//     height: 24em;\n//   }\n// }\n\n.kpf_table_overflow {\n  @media screen and (min-width: 1024px) and (max-width: 1439px) {\n    width: 100em;\n  }\n}\n\n.block_table {\n  display: inline-block;\n  border-spacing: 0;\n  // border: 1px solid black;\n  // width: 500px;\n  // position: relative;\n\n  .dnd_theader {\n    position: sticky;\n    top: 0;\n    // width: 100%;\n    // max-width: inherit;\n    background-color: #ffffff;\n    z-index: 2;\n    .th {\n      background: #dae1ec;\n    }\n  }\n  // .dnd_tbody {\n  //   // margin-top: 2em;\n  // }\n\n  .tr {\n    :last-child {\n      .td {\n        border-bottom: 0;\n      }\n    }\n  }\n\n  .th,\n  .td {\n    text-align: right;\n    margin: 0;\n    padding: 0.5rem;\n    border-bottom: 1px solid #58595d35;\n    border-right: 1px solid #58595d35;\n\n    position: relative;\n    .disable {\n      color: #4f515259;\n      background-color: #5252520d;\n    }\n    :last-child {\n      border-right: 0;\n    }\n    &.th_res {\n      width: 1.7em;\n    }\n\n    .resizer {\n      // display: inline-block;\n      background: #f9f9f9;\n      width: 0.4em;\n      height: 100%;\n      position: absolute;\n      right: 0;\n      top: 0;\n      transform: translateX(50%);\n      z-index: 1;\n\n      touch-action: none;\n\n      &.isResizing {\n        background: rgb(88, 168, 218);\n      }\n    }\n  }\n  .item_selected {\n    // .td{\n    // text-decoration: underline;\n    font-weight: 550;\n    background-color: #426ca60c;\n    // }\n  }\n  .th {\n    text-align: center;\n  }\n\n  .td {\n    font-style: italic;\n    font-weight: 400;\n  }\n}\n\n.project_list {\n  max-width: 100%;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  background: #ffffff;\n  // margin-bottom: 5px;\n  background: #ffffff;\n  // border: 1px solid #58595d35;\n  border-bottom: 0;\n  position: relative;\n  overflow-x: auto;\n  box-shadow: $reactTableShadow;\n\n  &.scrollX {\n    overflow-x: auto;\n  }\n  tr:nth-child(even) {\n    // background-color: rgb(243, 242, 242);\n    background-color: rgb(233 241 251 / 40%);\n  }\n\n  tr:nth-child(odd) {\n    background-color: white;\n  }\n\n  tbody {\n    tr {\n      &[data-readonly=\"false\"]:hover {\n        background-color: #426ca62f;\n      }\n    }\n  }\n  &:focus {\n    outline: none;\n  }\n\n  td {\n    .expand_cell_text {\n      display: none;\n    }\n    .expand_sign {\n      // text-decoration: underline;\n      text-align: center;\n      width: 100%;\n    }\n  }\n  td.expanded {\n    background-color: powderblue;\n    white-space: normal;\n    box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;\n\n    .expand_sign {\n      // display: none;\n    }\n    .expand_cell_text {\n      display: block;\n    }\n  }\n}\n\n.project_list_kp {\n  max-width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  background: #ffffff;\n  margin-bottom: 5px;\n  background: #ffffff;\n  border: 1px solid #58595d35;\n  border-bottom: 0;\n  position: relative;\n  &.scrollX {\n    overflow-x: scroll;\n  }\n\n  .kpf_table_tr:hover {\n    background-color: #426ca62f;\n  }\n}\n.row-even {\n  background-color: rgb(233 241 251 / 40%);\n}\n\n.row-odd {\n  background-color: white;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n}\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.566);\n}\n::-webkit-scrollbar-thumb {\n  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.486);\n}\n.radio_container {\n  display: flex;\n  justify-content: center;\n}\n.circules_box {\n  width: 14px;\n  height: 14px;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  .circule1 {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 14px;\n    width: 14px;\n    background-color: #eee;\n    border-radius: 50%;\n  }\n  .circule2 {\n    position: absolute;\n    top: 3.3px;\n    left: 3.3px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n  }\n}\n\n.availability_circule_box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin: 0 5px;\n\n  & .outer_circle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    box-sizing: content-box;\n\n    width: 12px;\n    height: 12px;\n\n    border-radius: 50%;\n    background-color: white;\n    border: 1px solid #426ca65e;\n\n    & .inner_circle {\n      flex-shrink: 0;\n      width: 8px;\n      height: 8px;\n      border-radius: 50%;\n    }\n  }\n}\n\n.item_selected {\n  td {\n    text-decoration: underline;\n    font-weight: 550;\n    background-color: #bfcde2aa;\n  }\n}\n\ntd {\n  white-space: nowrap; /* Запрет переноса текста на новую строку */\n  overflow: hidden; /* Скрытие текста, выходящего за пределы ячейки */\n  text-overflow: ellipsis;\n}\n\n.table {\n  max-width: 48vw;\n  display: inline-block;\n  border-spacing: 0;\n  // border: 1px solid black;\n\n  .tr {\n    :last-child {\n      .td {\n        border-bottom: 0;\n      }\n    }\n  }\n\n  .th,\n  .td {\n    margin: 0;\n    padding: 0.5rem;\n    border-bottom: 1px solid black;\n    border-right: 1px solid black;\n    position: relative;\n\n    :last-child {\n      border-right: 0;\n    }\n\n    .resizer {\n      display: inline-block;\n      background: blue;\n      width: 5px;\n      height: 100%;\n      position: absolute;\n      right: 0;\n      top: 0;\n      transform: translateX(50%);\n      z-index: 1;\n\n      touch-action: none;\n\n      &.isResizing {\n        background: red;\n      }\n    }\n  }\n}\n\n.table_container {\n  max-width: 50vw;\n}\n\nthead {\n  width: 100%;\n  position: sticky;\n  height: auto;\n  top: 0;\n  background: white;\n  z-index: 50;\n  overflow: auto;\n  border-bottom: 0.01px solid #58595d4b;\n  border-collapse: separate;\n  th {\n    border-collapse: separate;\n    font-style: normal;\n    font-weight: 500;\n    color: #426ba6;\n    align-items: center;\n    text-align: center;\n\n    border-right: 0.01px solid #58595d4b;\n    border-bottom: 0.01px solid #58595d4b;\n    &:last-child {\n      border-right: 0;\n    }\n  }\n}\ntable {\n  thead {\n    border-collapse: separate;\n  }\n  tbody {\n    border-collapse: collapse;\n  }\n}\n\n.table_with_bb {\n  max-width: 100%;\n\n  overflow-x: scroll;\n  background: #ffffff;\n  margin-bottom: 5px;\n  background: #ffffff;\n  border: 1px solid #58595d35;\n  border-bottom: 0;\n  position: relative;\n\n  thead {\n    height: 1.5em;\n    tr {\n      background-color: #426ca62f;\n    }\n  }\n  table {\n    tr {\n      border-bottom: 1px solid #426ca63b;\n      &:hover {\n        background-color: #426ca62f;\n      }\n      &:last-child {\n        border-bottom: 0;\n      }\n    }\n  }\n}\n\n.table_dnd_container {\n  // max-width: 100%;\n\n  overflow-x: scroll;\n  // position: relative;\n  // overflow: scroll;\n\n  // background: #FFFFFF;\n  // margin-bottom: 5px;\n  // background: #FFFFFF;\n  // border: 1px solid #58595d35;\n  // border-bottom:0;\n  // position: relative;\n  // .project_table {\n  //   // overflow-x: scroll;\n  // }\n  .project_list {\n    overflow-x: scroll;\n  }\n}\n.table_xscroll__container {\n  .project_list {\n    overflow-x: auto;\n  }\n}\n\n.modal_form__child {\n  .project_list {\n    // display: flex;\n    // align-self: stretch;\n    // min-height: 100%;\n  }\n}\n\n.reactTableRow {\n  cursor: pointer;\n\n  &:hover,\n  // &:focus,\n  &:active {\n    background-color: #bfcde24b;\n  }\n}\n\n.longColumnWrap {\n  height: auto;\n  vertical-align: top;\n  white-space: pre;\n  word-wrap: break-word;\n}\n\n.tar {\n  text-align: right;\n}\n\n.m0 {\n  margin: 0;\n}\n\n.sortableHeader {\n  position: relative;\n  cursor: pointer;\n\n  &::after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 6px;\n    height: 6px;\n    background-image: linear-gradient(to bottom right, transparent 50%, #426ba6 0);\n  }\n}\n\n.oneRow_table {\n  height: 4em;\n}\n\n.strikethroughRow {\n  position: relative;\n  text-decoration: line-through;\n  color: $placeholderColor;\n}\n\n.accentRow {\n  color: $accentColor;\n}\n\n// .strikethroughRow::before {\n//   content: \"\";\n//   position: absolute;\n//   top: 50%;\n//   left: -0.5em;\n//   width: calc(100% + 1em);\n//   height: 1px;\n//   background-color: rgb(66, 107, 166);\n//   transform: translateY(-50%);\n// }\n.resizer {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  right: 0;\n  width: 5px;\n  background: rgba(0, 0, 0, 0.5);\n  cursor: col-resize;\n  user-select: none;\n  touch-action: none;\n}\n\n.resizer.isResizing {\n  background: blue;\n  opacity: 1;\n}\n\n@media (hover: hover) {\n  .resizer {\n    opacity: 0;\n  }\n\n  *:hover > .resizer {\n    opacity: 1;\n  }\n}\n\n.react-table-disabled-td {\n  background-color: #8080802e !important;\n  color: gray;\n}\n.react-table-disabled-td-todo {\n  color: $placeholderColor;\n}\ntr.reactTableRow.react-table-linethrough {\n  color: $placeholderColor;\n  text-decoration: line-through;\n}\n","$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$borderColorLight: #dae1ec;\n$accentFilterColor: #ff8040;\n$accentColor: #b72025;\n$warningColor: #d3c71c;\n$succesColor: #00dbbb;\n$accentTableRowColor: #ecc0c1;\n$filtersBgColor: #d6dfea71; //#d6dfea\n$filterTitleColor: #d6dfea93;\n$textColor: #426ba6;\n$filtersBorderColor: #426ba6;\n$deletedTextColor: #b72025;\n$iconFill: #829ec4;\n$logoIcon: #6d91c6;\n$activeBtnColor: rgba(218, 225, 236, 1);\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n$btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;\n$reactTableShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;\n$dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;\n$commonShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$commonShadowHover: rgba(67, 71, 85, 0.27) 1px 1px 0.25em, rgba(90, 125, 188, 0.05) 1px 0.3em 1em;\n\n$transition: ease;\n$transitionFunc: cubic-bezier(0.25, 1, 0.5, 1);\n$iconHoverTransition: cubic-bezier(0.22, 1, 0.36, 1);\n$commonTransition: 0.3s $transitionFunc;\n\n:root {\n  --filterBtnBoxShadow: #{$filterBtnBoxShadow};\n  --btnBoxShadow: #{$btnBoxShadow};\n  --btnHoverBoxShadow: #{$btnHoverBoxShadow};\n  --dividerShadow: #{$dividerShadow};\n}\n\n$main-font: \"Roboto\", sans-serif;\n\n$font-weights: (\n  \"Light\": 300,\n  \"Regular\": 400,\n  \"Medium\": 500,\n  \"Bold\": 700,\n);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
